"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSingletonPopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const registries = new Map();
const getRegistry = (scope) => {
    let r = registries.get(scope);
    if (!r) {
        r = { active: null, subs: new Set(), next: 0 };
        registries.set(scope, r);
    }
    return r;
};
const useSingletonPopup = (scope) => {
    const reg = getRegistry(scope);
    const idRef = React.useRef(-1);
    if (idRef.current === -1)
        idRef.current = reg.next++;
    const id = idRef.current;
    const [active, setActive] = React.useState(reg.active);
    React.useEffect(() => {
        reg.subs.add(setActive);
        return () => {
            reg.subs.delete(setActive);
            if (reg.active === id) {
                reg.active = null;
                reg.subs.forEach((fn) => fn(null));
            }
        };
    }, [id, reg]);
    const setOpen = React.useCallback((next) => {
        const target = next ? id : null;
        if (reg.active === target)
            return;
        reg.active = target;
        reg.subs.forEach((fn) => fn(target));
    }, [id, reg]);
    return { id, open: active === id, setOpen };
};
exports.useSingletonPopup = useSingletonPopup;
